import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="visibility"
export default class extends Controller {
  static targets = [ "dynamic" ]

  connect() {
    this.hiddenClass = "hidden";
  }

  toggle() {
    this.dynamicTargets.forEach(target => {
      target.classList.toggle(this.hiddenClass);
    })
  }
}
